export default __webpack_public_path__ + "media/empty/empty-received-transfers-b9a6a0ae.jpg";